export const surveyJson = {
    "title": "Sorta Onboarding: Discover Your Decision Patterns",
    "showProgressBar": "top",
    "goNextPageAutomatic": false,
    "pages": [
      {
        "name": "pain_points",
        "title": "How is indecision harming you?",
        "elements": [
          {
            "type": "checkbox",
            "name": "harms",
            "title": "Select all that apply:",
            "isRequired": true,
            "choices": [
              "Lack of money",
              "Lack of confidence",
              "Anxiety",
              "Missed opportunities",
              "Relationships strained or neglected",
              "Wasted time",
              "Paralysis from perfectionism",
              "Looping thoughts that sap energy",
              "Feeling out of sync with your deeper self",
              "Always waiting for 'the right moment'"
            ]
          }
        ]
      },
      {
        "name": "coping",
        "title": "How do you usually handle indecision?",
        "elements": [
          {
            "type": "checkbox",
            "name": "coping_strategies",
            "title": "Select all that apply:",
            "isRequired": true,
            "choices": [
              "Talk to a friend",
              "Procrastinate",
              "Research obsessively",
              "Start making a list, then abandon it",
              "Flip a coin, then ignore the result",
              "Just do nothing and hope it resolves",
            ],
            "hasOther": true
          }
        ]
      },
      {
        "name": "feelings_frequency",
        "title": "How often do you feel the following?",
        "elements": [
          {
            "type": "rating",
            "name": "anxious_about_progress",
            "title": "Anxious about not making progress",
            "rateMin": 1,
            "rateMax": 5,
            "rateValues": [
              { "value": 1, "text": "Never" },
              { "value": 2, "text": "Rarely" },
              { "value": 3, "text": "Some days" },
              { "value": 4, "text": "Most days" },
              { "value": 5, "text": "Multiple times per day" }
            ]
          },
          {
            "type": "rating",
            "name": "guilty_for_indecision",
            "title": "Guilty for not choosing a direction",
            "rateMin": 1,
            "rateMax": 5,
            "rateValues": [
              { "value": 1, "text": "Never" },
              { "value": 2, "text": "Rarely" },
              { "value": 3, "text": "Some days" },
              { "value": 4, "text": "Most days" },
              { "value": 5, "text": "Multiple times per day" }
            ]
          },
          {
            "type": "rating",
            "name": "overwhelmed_by_choices",
            "title": "Overwhelmed by too many choices",
            "rateMin": 1,
            "rateMax": 5,
            "rateValues": [
              { "value": 1, "text": "Never" },
              { "value": 2, "text": "Rarely" },
              { "value": 3, "text": "Some days" },
              { "value": 4, "text": "Most days" },
              { "value": 5, "text": "Multiple times per day" }
            ]
          },
          {
            "type": "rating",
            "name": "envy_decisive_people",
            "title": "Envious of people who 'just know what to do'",
            "rateMin": 1,
            "rateMax": 5,
            "rateValues": [
              { "value": 1, "text": "Never" },
              { "value": 2, "text": "Rarely" },
              { "value": 3, "text": "Some days" },
              { "value": 4, "text": "Most days" },
              { "value": 5, "text": "Multiple times per day" }
            ]
          }
        ]
      },
      {
        "name": "indecision_pattern",
        "title": "What best describes your indecision?",
        "elements": [
          {
            "type": "checkbox",
            "name": "indecision_descriptions",
            "title": "Pick 2–3 statements that resonate with you:",
            "isRequired": true,
            "choices": [
              "I see too many paths, all with pros and cons",
              "I need to feel 100% sure before moving forward",
              "I don't trust my gut — it's been wrong before",
              "I'm scared of closing doors",
              "I get excited, then stall",
              "I just keep thinking until I burn out"
            ]
          }
        ]
      },
      {
        "name": "cost_of_indecision",
        "title": "Reflecting on indecision",
        "elements": [
          {
            "type": "comment",
            "name": "indecision_cost_example",
            "title": "When did indecision cost you something important? (optional)",
            "isRequired": false
          }
        ]
      },
      {
        "name": "first_decision",
        "title": "Let’s try something",
        "elements": [
          {
            "type": "comment",
            "name": "first_decision_context",
            "title": "Think of one decision bouncing around in your head. What’s the situation?",
            "isRequired": true
          }
        ]
      },
      {
        "name": "option_list",
        "title": "What are your options?",
        "elements": [
          {
            "type": "matrixdynamic",
            "name": "decision_options",
            "title": "List a few of the options you're considering.",
            "isRequired": true,
            "columns": [
              {
                "name": "option",
                "title": "Option",
                "cellType": "text"
              }
            ],
            "rowCount": 3,
            "addRowText": "Add option",
            "removeRowText": "Remove"
          }
        ]
      }
    ]
  }
  